export default __webpack_public_path__ + "static/media/fallback.2a0f1708.jpeg";